import { render, staticRenderFns } from "./Benefits.vue?vue&type=template&id=5886e52b&"
import script from "./Benefits.vue?vue&type=script&lang=ts&"
export * from "./Benefits.vue?vue&type=script&lang=ts&"
import style0 from "./Benefits.vue?vue&type=style&index=0&id=5886e52b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports